/* eslint-disable no-console */
import { assert, debug } from '@ember/debug';
import Service, { service } from '@ember/service';
import type DatadogService from 'garaje/services/datadog';
import { match } from 'macro-decorators';

export default class LoggerService extends Service {
  originalPageURL?: string;

  @service declare datadog: DatadogService;

  constructor(properties: Record<string, unknown>) {
    super(properties);
    this.originalPageURL = window.envoy?.originalPageURL;
  }

  @match('originalPageURL', /(:)([a-zA-Z0-9]{6})/g) isPreviewSHA!: boolean; // match production url against the dashboard.envoy.com:123ABC preview SHA format

  info(error: string): void {
    debug(error);
  }

  warn(messageOrError: string | Error, error?: Error): void {
    let message: string;
    if (messageOrError instanceof Error) {
      error = messageOrError;
      message = error.toString();
    } else {
      message = messageOrError;
    }
    console.warn(error);

    if (this.isPreviewSHA) return; // don't notify Datadog when the app is deployed as a preview SHA

    this.datadog.logWarning(message, {}, error);
  }

  error(messageOrError: string | Error, error?: Error): void {
    let message: string;
    if (messageOrError instanceof Error) {
      error = messageOrError;
      message = error.toString();
    } else {
      message = messageOrError;
    }
    console.error(error);

    if (this.isPreviewSHA) return; // don't notify Datadog when the app is deployed as a preview SHA

    this.datadog.logError(message, {}, error);
  }

  assert(message: string, condition: string): void {
    assert(message, condition);
  }
}
